const CURRENT_URL = new URL(window.location.href),
      CURRENT_URL_PARAMS = new URLSearchParams(CURRENT_URL.search);

class CollectionProducts extends HTMLElement {
  constructor() {
    super();
    this.productsContainer = this.querySelector('.collection-grid__products');
    this.sortingSelect = this.querySelector('.collection-grid__sort form');

    this.setupEventListeners();
  }
    
  setupEventListeners() {
    this.sortingSelect.addEventListener('change', () => {
      const sortingOption = this.sortingSelect.querySelector('input:checked').value;

      CURRENT_URL_PARAMS.set('sort_by', sortingOption);
      window.location.replace(CURRENT_URL.toString().split('?')[0] + '?' + CURRENT_URL_PARAMS.toString());
    });
  }
}

customElements.define('collection-products', CollectionProducts);
